import { produce } from "immer";
import {
  FETCH_ENQUIRIES,
  FETCH_ENQUIRIES_SUCCESS,
  FETCH_ENQUIRIES_FAILURE,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_SUCCESS,
  GET_VIEW_DATA_FAILURE,
  //
  ADD_ENQUIRY,
  ADD_ENQUIRY_SUCCESS,
  ADD_ENQUIRY_FAILURE,
  //
  EDIT_ENQUIRY,
  EDIT_ENQUIRY_SUCCESS,
  EDIT_ENQUIRY_FAILURE,
  //
  DELETE_ENQUIRY,
  DELETE_ENQUIRY_SUCCESS,
  DELETE_ENQUIRY_FAILURE,
  //
  DELETE_ENQUIRY_NOTE,
  DELETE_ENQUIRY_NOTE_FAILURE,
  DELETE_ENQUIRY_NOTE_SUCCESS,
  //
  DELETE_ENQUIRY_REMINDER_NOTE,
  DELETE_ENQUIRY_REMINDER_NOTE_FAILURE,
  DELETE_ENQUIRY_REMINDER_NOTE_SUCCESS,
  //
  OPEN_NOTE_ADD_MODAL,
  CLOSE_NOTE_ADD_MODAL,
  //
  OPEN_REMINDER_ADD_MODAL,
  CLOSE_REMINDER_ADD_MODAL,
  //
  ADD_ENQUIRY_NOTE,
  ADD_ENQUIRY_NOTE_SUCCESS,
  ADD_ENQUIRY_NOTE_FAILURE,
  //
  FETCH_ENQUIRIES_NOTES,
  FETCH_ENQUIRIES_NOTES_FAILURE,
  FETCH_ENQUIRIES_NOTES_SUCCESS,
  //
  ADD_ENQUIRY_REMINDER,
  ADD_ENQUIRY_REMINDER_SUCCESS,
  ADD_ENQUIRY_REMINDER_FAILURE,
  //
  FETCH_ENQUIRIES_REMINDERS,
  FETCH_ENQUIRIES_REMINDERS_FAILURE,
  FETCH_ENQUIRIES_REMINDERS_SUCCESS,
  //
  EXPORT_ENQUIRY,
  EXPORT_ENQUIRY_FAILURE,
  EXPORT_ENQUIRY_SUCCESS,
  //
  IMPORT_ENQUIRY,
  IMPORT_ENQUIRY_FAILURE,
  IMPORT_ENQUIRY_SUCCESS,
} from "./constants";

export const initialState = {
  isFetchingEnquiries: false,
  isFetchingEnquiriesNotes: false,
  isFetchingEnquiriesReminders: false,
  enquiries: [],
  enquiriesNotes: [],
  enquiriesReminders: [],
  // Add / Edit
  isSubmitting: false,
  // View
  isFetching: false,
  currentEnquiry: {},
  currentEnquiryNote: {},
  currentEnquiryReminder: {},
  // Delete
  isDeleting: false,
  isNoteAddModalOpen: false,
  isReminderAddModalOpen: false,
};

const EnquiriesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_ENQUIRIES:
        draft.isFetchingEnquiries = true;
        draft.currentEnquiry = {};
        break;
      case FETCH_ENQUIRIES_SUCCESS:
        draft.isFetchingEnquiries = false;
        draft.enquiries = action.payload;
        break;
      case FETCH_ENQUIRIES_FAILURE:
        draft.isFetchingEnquiries = false;
        break;
      // View
      case GET_VIEW_DATA:
        draft.isFetching = true;
        draft.currentEnquiry = {};
        break;
      case GET_VIEW_DATA_SUCCESS:
        draft.isFetching = false;
        draft.currentEnquiry = action.payload;
        break;
      case GET_VIEW_DATA_FAILURE:
        draft.isFetching = false;
        break;
      // Add
      case ADD_ENQUIRY:
        draft.isSubmitting = true;
        break;
      case ADD_ENQUIRY_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_ENQUIRY_FAILURE:
        draft.isSubmitting = false;
        break;
      // Edit
      case EDIT_ENQUIRY:
        draft.isSubmitting = true;
        break;
      case EDIT_ENQUIRY_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EDIT_ENQUIRY_FAILURE:
        draft.isSubmitting = false;
        break;
      // Delete
      case DELETE_ENQUIRY:
        draft.isDeleting = true;
        break;
      case DELETE_ENQUIRY_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_ENQUIRY_FAILURE:
        draft.isDeleting = false;
        break;
      // Delete Note
      case DELETE_ENQUIRY_NOTE:
        draft.isDeleting = true;
        break;
      case DELETE_ENQUIRY_NOTE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_ENQUIRY_NOTE_FAILURE:
        draft.isDeleting = false;
        break;
      // Delete Reminder Note
      case DELETE_ENQUIRY_REMINDER_NOTE:
        draft.isDeleting = true;
        break;
      case DELETE_ENQUIRY_REMINDER_NOTE_SUCCESS:
        draft.isDeleting = false;
        break;
      case DELETE_ENQUIRY_REMINDER_NOTE_FAILURE:
        draft.isDeleting = false;
        break;
      // NOTE OPEN
      case OPEN_NOTE_ADD_MODAL:
        draft.isNoteAddModalOpen = true;
        break;
      case CLOSE_NOTE_ADD_MODAL:
        draft.isNoteAddModalOpen = false;
        break;
      // REMINDER OPEN
      case OPEN_REMINDER_ADD_MODAL:
        draft.isReminderAddModalOpen = true;
        break;
      case CLOSE_REMINDER_ADD_MODAL:
        draft.isReminderAddModalOpen = false;
        break;
      case ADD_ENQUIRY_NOTE:
        draft.isSubmitting = true;
        break;
      case ADD_ENQUIRY_NOTE_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_ENQUIRY_NOTE_FAILURE:
        draft.isSubmitting = false;
        break;
      // List
      case FETCH_ENQUIRIES_NOTES:
        draft.isFetchingEnquiriesNotes = true;
        draft.currentEnquiryNote = {};
        break;
      case FETCH_ENQUIRIES_NOTES_SUCCESS:
        draft.isFetchingEnquiriesNotes = false;
        draft.enquiriesNotes = action.payload;
        break;
      case FETCH_ENQUIRIES_NOTES_FAILURE:
        draft.isFetchingEnquiriesNotes = false;
        break;
      case ADD_ENQUIRY_REMINDER:
        draft.isSubmitting = true;
        break;
      case ADD_ENQUIRY_REMINDER_SUCCESS:
        draft.isSubmitting = false;
        break;
      case ADD_ENQUIRY_REMINDER_FAILURE:
        draft.isSubmitting = false;
        break;
      // List
      case FETCH_ENQUIRIES_REMINDERS:
        draft.isFetchingEnquiriesReminders = true;
        draft.currentEnquiryReminder = {};
        break;
      case FETCH_ENQUIRIES_REMINDERS_SUCCESS:
        draft.isFetchingEnquiriesReminders = false;
        draft.enquiriesReminders = action.payload;
        break;
      case FETCH_ENQUIRIES_REMINDERS_FAILURE:
        draft.isFetchingEnquiriesReminders = false;
        break;
      // EXPORT ENQUIRY
      case EXPORT_ENQUIRY:
        draft.isSubmitting = true;
        break;
      case EXPORT_ENQUIRY_SUCCESS:
        draft.isSubmitting = false;
        break;
      case EXPORT_ENQUIRY_FAILURE:
        draft.isSubmitting = false;
        break;
      case IMPORT_ENQUIRY:
        draft.isSubmitting = true;
        break;
      case IMPORT_ENQUIRY_SUCCESS:
        draft.isSubmitting = false;
        break;
      case IMPORT_ENQUIRY_FAILURE:
        draft.isSubmitting = false;
        break;
      default:
        return state;
    }
  });

export default EnquiriesReducer;
